let unlockSessionReady = false;

export function markUnlockSessionReady() {
  unlockSessionReady = true;
}

export function clearUnlockSessionReady() {
  unlockSessionReady = false;
}

export function isUnlockSessionReady() {
  return unlockSessionReady;
}
